import React, { useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';
import ExcelExportButton, { ISheet } from '../../../../components/ExcelExportButton';

export interface IExcelByGameProps {
    list: any[];
}

const ExcelByGame: React.FC<IExcelByGameProps> = ({ list }) => {

    const [exportSheets, setExportSheets] = useState<ISheet[]>([]);

    useEffect(() => {

        if (!list) return;

        let sheets = [];

        sheets.push({
            sheetName: "Game Stats",
            sheetColumns: [
                { title: "Name", name: "gameName" },
                { title: "Games Played", name: "gamesPlayed" },
                { title: "Answer Accuracy", name: "averageAccuracy" },
                { title: "Play Time", name: "timePlayed" },
            ],
            sheetData: list || []
        });

        setExportSheets(sheets);

    }, [list]);

    return (
        <ExcelExportButton 
            fileName='DataExport' 
            buttonTitle='Download' 
            sheets={exportSheets}
            buttonProps={{size: "small", variant: "outlined", style: { backgroundColor: 'white' }}}
        >
            <Typography style={{ fontWeight: 600, fontSize: 14 }}>Export</Typography>
        </ExcelExportButton>
    );
}

export default ExcelByGame;